import EmpEmploymentContent from "./employeeinfo/EmpEmploymentContent";
import EmpEleaveContent from "./employeeinfo/EmpEleaveContent";
import EmpInfoContent from "./employeeinfo/EmpInfoContent";
import EmpProbationContent from "./employeeinfo/EmpProbationContent";
import EmpPositionContent from "./employeeinfo/EmpPositionContent";

export default function EmployeeInfo({ userData, handleEvents }) {
  const boxName = "content-employeeinfo";

  return (
    <div id="employeeinfo-box" className="">
      <EmpInfoContent
        boxName={boxName}
        userData={userData}
        handleEvents={handleEvents}
      />
      <EmpEmploymentContent
        boxName={boxName}
        userData={userData}
        handleEvents={handleEvents}
      />
      <EmpProbationContent
        boxName={boxName}
        userData={userData}
        handleEvents={handleEvents}
      />
      <EmpPositionContent
        boxName={boxName}
        userData={userData}
        handleEvents={handleEvents}
      />
      <EmpEleaveContent
        boxName={boxName}
        userData={userData}
        handleEvents={handleEvents}
      />
    </div>
  );
}
